import React from 'react'
import { makeStyles } from '@material-ui/core'
import AcronymIcon from './acronym-icon'

const useStyles = makeStyles((theme) => ({
  icon: props => ({
    width: theme.custom.orgIcon[props.variant ?? 'medium'].size,
    height: theme.custom.orgIcon[props.variant ?? 'medium'].size,
    borderRadius: '50%',
    overflow: 'hidden'
  })
}), { name: 'MuiGlueOrgIcon' })

const OrgIcon = (props) => {
  const classes = useStyles(props)
  return (
    <div className={classes.icon}>
      <AcronymIcon
        text={props.name}
        id={props.id}
        typeVariant={props.typeVariant ?? 'h3'}
      />
    </div>
  )
}

export default OrgIcon
